import {
  QUESTION_SET_FETCH_REQUEST,
  QUESTION_SET_FETCH_SUCCESS,
  QUESTION_SET_FETCH_FAILURE,
} from "./actionTypes"

const INIT_STATE = {
  questionSets: {},  // questionSetId → full info
  loading: {},
  error: {}
}

const questionSetDetailsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case QUESTION_SET_FETCH_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, [action.topicId]: true },
        error: { ...state.error, [action.topicId]: null }
      };
    case QUESTION_SET_FETCH_SUCCESS: {
      const newData = {};
      for (const qs of action.payload) {
        newData[qs._id] = qs;
      }

      return {
        ...state,
        questionSets: { ...state.questionSets, ...newData },
        loading: {}, // reset all for simplicity; or track by topicId
        error: {}
      };
    }
    case QUESTION_SET_FETCH_FAILURE:
      return {
        ...state,
        loading: {},
        error: { ...state.error, general: action.error }
      };
    default:
      return state;
  }
};

export default questionSetDetailsReducer;




